function spread(callback){return function wrap(arr){return callback.apply(null,arr)}}

export { spread as default };
//# sourceMappingURL=spread.js.map
